var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.218C4 5.242 4.755 4.5 5.905 4.5c1.149 0 1.86.737 1.882 1.709 0 .958-.733 1.717-1.904 1.717H5.86c-1.128 0-1.86-.754-1.86-1.708zM16.045 9.071c-1.787 0-2.906.968-3.114 1.644V9.163H9.426c.044.824 0 9.88 0 9.88h3.505v-5.344-.1c-.002-.264-.003-.518.078-.707.243-.594.759-1.21 1.687-1.21 1.215 0 1.77.916 1.77 2.252v5.113H20v-5.495c0-3.062-1.739-4.48-3.955-4.48zM7.522 9.163H4.404v9.88h3.118v-9.88z",
    fill: "#ACB5BD"
  })));
}

export default SvgLinkedin;